import { useEffect } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
/** popper-free, very basic alignment for when all the fancy stuff is
 *  overkill and performance matters */
export function useBasicPopoverPositioning(contentNode, popoverNode, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.placement, placement = _c === void 0 ? 'right' : _c, _d = _b.secondaryPlacement, secondaryPlacement = _d === void 0 ? 'middle' : _d, _e = _b.enabled, enabled = _e === void 0 ? true : _e, _f = _b.updatePositionOnScroll, updatePositionOnScroll = _f === void 0 ? true : _f, _g = _b.throttleDelay, throttleDelay = _g === void 0 ? 100 : _g;
    var positionTooltip = useThrottle(function () {
        if (!contentNode || !popoverNode) {
            return;
        }
        var contentRect = contentNode.getBoundingClientRect();
        var tooltipRect = popoverNode.getBoundingClientRect();
        popoverNode.style.position = 'fixed';
        popoverNode.style.willChange = 'transform';
        // TODO: add support for other placements
        switch (placement) {
            case 'right':
            default:
                popoverNode.style.top = '0';
                popoverNode.style.left = "".concat(contentRect.right, "px");
                switch (secondaryPlacement) {
                    case 'start':
                        popoverNode.style.transform = "translateY(".concat(contentRect.y - contentRect.height / 2, "px)");
                        break;
                    case 'end':
                        popoverNode.style.transform = "translateY(".concat(contentRect.y + contentRect.height - tooltipRect.height, "px)");
                        break;
                    case 'middle':
                    default:
                        popoverNode.style.transform = "translateY(".concat(contentRect.y + contentRect.height / 2 - tooltipRect.height / 2, "px)");
                }
        }
    }, [contentNode, popoverNode, placement], throttleDelay, { leading: true, trailing: true });
    useEffect(function () {
        if (!enabled) {
            return;
        }
        positionTooltip();
        if (updatePositionOnScroll) {
            window.addEventListener('scroll', positionTooltip);
            return function () {
                window.removeEventListener('scroll', positionTooltip);
            };
        }
    }, [enabled, positionTooltip, updatePositionOnScroll]);
    return { positionTooltip: positionTooltip };
}
//# sourceMappingURL=useBasicPopoverPositioning.js.map